import React from 'react';
import styles from './styles';
import axiosConfig from '../../../config/axios.config.js';

const SessionActivationErrorPage = props => {
  return(
    <div style={styles.container}>
      <div style={styles.content}>
        <h3 style={styles.message}>Uh oh. Looks like something went wrong loggin you in.</h3>
        <a style={styles.btn} href={axiosConfig.ssoUrl + '/?app=xt_console'}>Return to Login</a>
      </div>
    </div>
  )
}

export default SessionActivationErrorPage;
